export default {
  batch: {
    status: "狀態",
    totalDistance: "總距離 (km)",
    productionEmission: "生產排放 (kg CO2e)",
    transportEmission: "運輸排放 (kg CO2e)",
    totalEmission: "總排放 (kg CO2e)",
    tax: "稅費 (€)",
    more: "更多",
    fallbackDistanceWarning: "使用備用方法計算距離，可能存在誤差",
  },
  label: {
    start: "起點",
    end: "終點",
    via: "途經",
    mode: "運輸方式",
    weight: "重量",
    cnCode: "商品編碼",
  },
  placeholder: {
    start: "例如：上海，中國",
    end: "例如：鹿特丹，荷蘭",
    via: "例如：新加坡，SG",
    mode: "運輸方式",
    weight: "輸入重量",
    cnCode: "例如：25070080 或水泥",
    location: "例如：上海，中國",
  },
  action: {
    addVia: "新增途經點",
    remove: "移除",
    calculate: "計算",
    loadMore: "載入更多",
  },
  transport: {
    sea: "海運",
    road: "公路",
    rail: "鐵路",
    barge: "駁船",
  },
  unit: {
    tonne: "噸",
    kilogram: "公斤",
    pound: "磅",
  },
  leg: {
    enable_detailed_mode: "啟用詳細模式以顯示排放係數",
    detailed_mode: "詳細模式",
    simple_mode: "簡易模式",
    origin: "起點",
    destination: "目的地",
    transport_mode: "運輸方式",
    distance: "距離 (km)",
    weight: "重量 (t)",
    cn_code: "商品編碼",
    transport_emission: "運輸排放 (kg CO2e)",
    transport_emission_factor: "運輸排放係數",
    transport_emission_factor_id: "運輸排放係數 ID",
    production_emission: "生產排放 (kg CO2e)",
    production_emission_factor: "生產排放係數",
    production_emission_factor_id: "生產排放係數 ID",
    total_emission: "總排放 (kg CO2e)",
  },
  error: {
    cnCodeSearchFailed: "商品編碼搜尋失敗",
    cnCodeSearchFailedDesc: "無法查詢可用的商品編碼，請檢查網路。",
    locationRequired: "請輸入地點",
    modeRequired: "請選擇運輸方式",
    requiredFields: "請填寫所有必填欄位",
    calculationFailed: "計算失敗",
    checkInputs: "請檢查輸入或稍後再試",
    cnCodeRequired: "請輸入商品編碼",
    weightRequired: "請輸入重量",
    maxViaPoints: "最多允許 3 個途經點",
    cnCodeInvalid: "商品編碼只能包含字母、數字和底線，最長 20 個字元",
    weightPositive: "重量必須為正數",
    locationSearchFailed: "地點搜尋失敗",
    locationSearchFailedDesc: "無法連接到地點服務，請稍後再試。",
  },
  result: {
    title: "計算結果",
    selected: "選定選項",
    alternative: "推薦選項 ({mode})",
    leg: "航段 {index}",
    totalDistance: "總距離",
    productionEmission: "生產排放",
    transportEmission: "運輸排放",
    totalEmission: "總排放",
    tax: "碳稅",
  },
  page: {
    title: "CBAM 排放計算器",
    single: "單次計算",
    batchTitle: "批次計算",
    batch: {
      rowNumber: "行號",
      cnCode: "商品編碼",
      weight: "重量 (t)",
      originCity: "起點城市",
      originCoords: "起點座標",
      destinationCity: "目的地城市",
      destinationCoords: "目的地座標",
      transportMode: "運輸方式",
      error: "錯誤",
      errorRowsDetected: "檢測到 {count} 行錯誤資料，已自動排除。僅儲存 {validCount} 行有效資料。",
      errors: {
        invalidCsvHeader: "CSV 標頭無效",
        headerMustBe: "標頭必須為：{fields}",
        batchSizeExceed: "批次大小不能超過 {maxSize}",
        csvValidationFailed: "CSV 驗證失敗",
        checkFormat: "檢查格式或重試",
        invalidXlsxFile: "XLSX 檔案無效",
        fileIsEmpty: "檔案為空",
        invalidXlsxHeader: "XLSX 標頭無效",
        xlsxValidationFailed: "XLSX 驗證失敗",
      },
    },
    upgradeTip: "升級到專業版以解鎖分段重量和商品編碼計算功能，提高 CBAM 合規準確性！",
    learnMore: "了解更多",
    reportTitle: "排放報告",
    viewReport: "查看報告",
    totalOverview: "總覽",
    origin: "起點",
    destination: "目的地",
    totalDistance: "總距離",
    tax: "稅費",
    basedOnEUR: "基於 €{amount}",
    productionEmission: "生產排放",
    transportEmission: "運輸排放",
    totalEmission: "總排放",
    pleaseCalculateFirst: "請先進行計算",
    batchLimitInfo: "免費用戶支援最多 10 筆記錄，付費用戶支援最多 200 筆記錄。",
    clearErrorData: "清除錯誤資料",
    submitCalculation: "提交計算",
    confirmDeleteTask: "確定要刪除此任務嗎？",
    reupload: "重新上傳",
    uploadHint: "點擊或拖拽檔案到此區域以上傳",
    csvOnlyHint: "免費版僅支援 CSV，付費用戶支援 CSV 和 XLSX",
    configFailed: "獲取設定失敗，請重試",
    batchResultSummary: "共 {total} 筆記錄，{success} 筆成功，{fail} 筆失敗",
    searchByCNCode: "按商品編碼搜尋",
    downloadCSVTemplate: "下載 CSV 模板",
    downloadXLSXTemplate: "下載 XLSX 模板",
    previewReport: "預覽報告",
    to: "至",
    // 模板相關翻譯
    template: {
      saveTemplate: "儲存模板",
      templateName: "模板名稱",
      namePlaceholder: "請輸入模板名稱",
      nameRequired: "請輸入模板名稱",
      nameTooLong: "模板名稱不能超過 50 個字元",
      formIncomplete: "儲存模板前請先完成表單",
      saveSuccess: "模板儲存成功",
      saveFailed: "模板儲存失敗",
    },
  },
  tooltip: {
    cnCode: "商品編碼由字母、數字和底線組成，最多 20 個字元",
  },
  progress: {
    title: "批次計算",
    stages: {
      connecting: "連接中",
      connected: "已連接",
      validating: "驗證中",
      validated: "已驗證",
      calculating: "計算中",
      completed: "計算完成",
    },
    close: "關閉",
    regenerate: "重新生成",
    addFactor: "新增係數",
  },
  location: {
    noMatch: "無相符結果",
    enterKeyword: "請輸入關鍵字",
  },
  plan: {
    trialExceeded: "試用計算次數已超過 ({count})",
    trialExpired: "試用期已過期",
    monthlyExceeded: "本月計算次數已超過 ({count})",
    subscriptionExpired: "訂閱期已過期",
  },
};
